import { styled } from "@material-ui/core";
import Box from "@material-ui/core/Box";

export default styled(Box)({
  fontSize: "14px",
  lineHeight: "2Opx",
  fontWeight: 400,
});
